import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoaderService } from '../../components/loader/service/loader.service';
import { DashboardService } from '../services/dashboard.service';
import { Router } from '@angular/router';
import { MembersService } from 'src/app/members/members.service';
import { DialogComponent, DialogData } from 'src/app/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { BannerService } from 'src/app/banner/services/banner.service';
import { environment } from '../../../environments/environment';
const animation = { duration: 5000, easing: (t) => t };

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['../../../../node_modules/keen-slider/keen-slider.min.css', './dashboard.component.css'],
})
export class DashboardComponent {
  @ViewChild('sliderRef') sliderRef: ElementRef<HTMLElement>;

  env = environment;
  currentSlide: number = 1;
  dotHelper: Array<Number> = [];

  public membersCount: number = 0;
  banners: any = [];
  groupsCount: number = 0;
  lastFrequencies = 0;
  birthdays: any = [];
  months = ['JAN.', 'FEV.', 'MAR.', 'ABR.', 'MAI.', 'JUN.', 'JUL.', 'AGO.', 'SET.', 'OUT.', 'NOV.', 'DEZ.'];

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5'],
  };
  view: any[] = [170, 120];
  chartSingle = [
    {
      name: '',
      value: 8940000,
    },
  ];
  slider: KeenSliderInstance = null;
  async ngAfterViewInit() {
    this.banners = await this.bannerService.getBanners();
    setTimeout(() => {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        loop: true,
        drag: true,
        renderMode: 'performance',
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel;
        },
      });
      this.dotHelper = [...Array(this.slider.track.details.slides.length).keys()];
    });
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  constructor(
    private dashboardService: DashboardService,
    private loadService: LoaderService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private memberSerice: MembersService,
    private dialog: MatDialog,
    private bannerService: BannerService
  ) {
    this.getCards();
    this.getAniversary();
    this.pendency();
    this.getBanners();
  }
  firstFormGroup: FormGroup = this._formBuilder.group({ firstCtrl: [''] });
  secondFormGroup: FormGroup = this._formBuilder.group({ secondCtrl: [''] });
  images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);

  getCards(): Promise<any> {
    this.loadService.showLoader();
    return this.dashboardService
      .getCards()
      .then((res) => {
        this.membersCount = res.users;
        this.groupsCount = res.groups;
        this.lastFrequencies = res.frequencies;
        this.loadService.closeLoader();
      })
      .catch((err) => {
        this.loadService.closeLoader();
      });
  }

  startFrequency(groupWordId: number, groupId: number) {
    this.router.navigate(['frequencia/add'], {
      queryParams: { groupWordId, groupId },
    });
  }

  async getBanners() {
    console.log(this.banners);
  }

  getAniversary() {
    this.memberSerice.getBirthdays().then((res) => {
      this.birthdays = res;
    });
  }

  getAvatar(memberAvatar: any): any {
    if (!memberAvatar) {
      return environment.endPointApi + 'user/avatar/default-user.png';
    } else {
      return environment.endPointApi + 'user/avatar/' + (memberAvatar.file_name || memberAvatar);
    }
  }

  pendency() {
    const pendencies = sessionStorage.getItem('pendencies');

    if (pendencies) {
      const keys = Object.keys(JSON.parse(pendencies))[0];

      const dialogData = {
        width: '400px',
        height: '250px',
        data: { title: 'Pendencia', text: 'Você ainda não aceitou os nossos termos de serviço ' },
      };

      const dialogRef = this.dialog.open(DialogComponent, dialogData);
      dialogRef.afterClosed().subscribe((res) => {
        this.router.navigateByUrl(JSON.parse(pendencies)[keys].route);
      });
    }
  }
}
